if (!customElements.get("variant-dropdown")) {
  customElements.define(
    "variant-dropdown",
    class VariantDropdown extends DrawerBase {
      // ── Cached elements ──
      #dropdownIcon;
      #drawerList;
      #featuredProductSection;
      #isInsideFeaturedProductSection;

      // ── Required overrides ──
      get container() {
        return this.querySelector(".wt-product__option__body");
      }
      get trigger() {
        return this.querySelector(".wt-product__option__dropdown");
      }
      get closeButton() {
        return this.querySelector(".drawer__list-nav__close");
      }

      // ── Optional overrides ──
      get bodyOverlayClasses() {
        return ["variant-dropdown-page-overlay"];
      }
      get overlay() {
        return this.previousElementSibling;
      }
      get tabindexTargets() {
        return ".drawer__list__link, .drawer__list-nav__close";
      }

      onConnected() {
        this.#dropdownIcon = this.trigger?.querySelector("svg");
        this.#drawerList = this.querySelector(".drawer__list");
        this.#featuredProductSection = this.closest(".wt-featured-product");
        this.#isInsideFeaturedProductSection = this.#featuredProductSection !== null;

        // When a <select> inside the drawer changes: update trigger label + close
        const select = this.container?.querySelector("select");
        if (select) {
          this._boundSelectChange = () => {
            const triggerLabel = this.trigger?.querySelector("[data-selected-swatch-value]");
            if (triggerLabel) triggerLabel.textContent = select.value;
            this.closeDrawer();
          };
          select.addEventListener("change", this._boundSelectChange);
        }
      }

      onOpen() {
        if (this.#dropdownIcon) this.#dropdownIcon.classList.add("open");
        if (this.#isInsideFeaturedProductSection) {
          this.#featuredProductSection.classList.add(
            "wt-featured-product--active-variant-dropdown"
          );
        }
      }

      onClose() {
        if (this.#dropdownIcon) this.#dropdownIcon.classList.remove("open");
        if (this.#isInsideFeaturedProductSection) {
          this.#featuredProductSection.classList.remove(
            "wt-featured-product--active-variant-dropdown"
          );
        }
      }

      shouldCloseOnClick(event) {
        const inside = this.container.contains(event.target);
        const onTrigger = event.target === this.trigger || this.trigger.contains(event.target);
        const onOption = this.#drawerList?.contains(event.target);
        return (!inside && !onTrigger) || onOption;
      }

      disconnectedCallback() {
        const select = this.container?.querySelector("select");
        if (select && this._boundSelectChange) {
          select.removeEventListener("change", this._boundSelectChange);
        }
        super.disconnectedCallback();
      }
    }
  );
}
